'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dData$002dForm from "./app.data.-App-Document-Data-Form.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentDataForm$Invoice$() {
}
export { $c_Lapp_data_AppDocumentDataForm$Invoice$ as $c_Lapp_data_AppDocumentDataForm$Invoice$ };
$p = $c_Lapp_data_AppDocumentDataForm$Invoice$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentDataForm$Invoice$;
/** @constructor */
function $h_Lapp_data_AppDocumentDataForm$Invoice$() {
}
export { $h_Lapp_data_AppDocumentDataForm$Invoice$ as $h_Lapp_data_AppDocumentDataForm$Invoice$ };
$h_Lapp_data_AppDocumentDataForm$Invoice$.prototype = $p;
$p.n = (function() {
  return "Invoice";
});
$p.bKk = (function(x$0) {
  return new $j_app$002edata$002e$002dApp$002dDocument$002dData$002dForm.$c_Lapp_data_AppDocumentDataForm$Invoice(x$0.e(0));
});
$p.U = (function(p) {
  return this.bKk(p);
});
var $d_Lapp_data_AppDocumentDataForm$Invoice$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentDataForm$Invoice$, "app.data.AppDocumentDataForm$Invoice$", ({
  B7: 1,
  d: 1,
  e: 1
}));
export { $d_Lapp_data_AppDocumentDataForm$Invoice$ as $d_Lapp_data_AppDocumentDataForm$Invoice$ };
var $n_Lapp_data_AppDocumentDataForm$Invoice$;
function $m_Lapp_data_AppDocumentDataForm$Invoice$() {
  if ((!$n_Lapp_data_AppDocumentDataForm$Invoice$)) {
    $n_Lapp_data_AppDocumentDataForm$Invoice$ = new $c_Lapp_data_AppDocumentDataForm$Invoice$();
  }
  return $n_Lapp_data_AppDocumentDataForm$Invoice$;
}
export { $m_Lapp_data_AppDocumentDataForm$Invoice$ as $m_Lapp_data_AppDocumentDataForm$Invoice$ };
//# sourceMappingURL=app.data.-App-Document-Data-Form$-Invoice$.js.map
